import { updateItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 md:mb-12">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              最新快讯
            </h2>
            <p className="text-sm text-foreground-500">
              按时间线梳理最新吃瓜动态，第一时间了解爆料进展
            </p>
          </div>

          <div className="relative">
            <div className="absolute left-[15px] md:left-[19px] top-2 bottom-2 w-px bg-background-300" />

            <div className="space-y-6">
              {updateItems.map((item) => (
                <div key={item.id} className="relative flex gap-4 md:gap-6 pl-10 md:pl-12 group">
                  <span className="absolute left-0 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50 border-2 border-background-300 group-hover:border-primary-400 transition-colors">
                    <span className="w-2.5 h-2.5 rounded-full bg-primary-500" />
                  </span>

                  <div className="flex-1 pb-2">
                    <div className="flex items-center gap-2 mb-2 flex-wrap">
                      <span className="text-xs font-medium text-foreground-500 whitespace-nowrap">
                        {item.time}
                      </span>
                      {item.badge && (
                        <span className={`px-1.5 py-0.5 rounded text-xs font-medium whitespace-nowrap ${
                          item.badge === '最新'
                            ? 'bg-primary-100 text-primary-700'
                            : 'bg-accent-100 text-accent-700'
                        }`}>
                          {item.badge}
                        </span>
                      )}
                    </div>
                    <h3 className="text-sm md:text-base font-medium text-foreground-900 mb-1">
                      {item.title}
                    </h3>
                    <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}